module.exports = __webpack_public_path__ + "assets/img/ju2.686f1416.png";